import { connect } from 'react-redux';
import { compose, withProps, flattenProp } from 'recompose';
import {
  withFirebase,
  withFirestore,
  isEmpty,
  isLoaded
} from 'react-redux-firebase';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { closeSignupModal } from '../../../store/actions/signupModalActions';
import { signUp } from '../../../store/actions/authActions';
import { saveProfile } from '../../../store/actions/influencerActions';
import { signInWithYoutube } from '../../../store/actions/youtubeActions';

const styles = theme => ({
  modalStyles: {
    display: 'flex'
  },
  submitButton: {
    marginTop: '30px',
    color: '#ffffff'
  },
  loadingSpinner: {
    position: 'absolute',
    top: '50%',
    right: '50%'
  }
});

const mapStateToProps = state => {
  return {
    showModal: state.signupModal.signupModalIsOpen,
    companySignup: state.signupModal.companySignup,
    influencerSignup: state.signupModal.influencerSignup,
    authError: state.auth.authError,
    processingSignup: state.auth.processingSignup,
    auth: state.firebase.auth,
    profile: state.firebase.profile
  };
};

const mapDispatchToProps = dispatch => {
  return {
    closeSignupModal: () => dispatch(closeSignupModal()),
    signUp: creds => dispatch(signUp(creds)),
    saveProfile: influencerInfo => dispatch(saveProfile(influencerInfo)),
    signInWithYoutube: async (firstName, lastName, onComplete) =>
      dispatch(signInWithYoutube(firstName, lastName, onComplete)).then(
        response => {
          onComplete(response);
        }
      )
  };
};

export default compose(
  // Map redux state to props
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  // Add props.router (used in handlers)
  withRouter,

  // Add props.firebase (used in handlers)
  withFirebase,
  withFirestore,

  // Add custom props
  withProps(({ auth, profile }) => ({
    authExists: isLoaded(auth) && !isEmpty(auth),
    auth,
    profile
  })),
  // Flatten profile so that avatarUrl and displayName are props
  flattenProp('profile'),
  // Add styles as classes prop
  withStyles(styles)
);



// WEBPACK FOOTER //
// ./src/components/shared/signUpModal/Signup.enhancer.js